module.exports = __webpack_public_path__ + "img/Primordial-Process-6.8b91ab86.png";